import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useHistory} from 'react-router-dom';
import styled from 'styled-components';

import {labels} from '../../util/utils';
import {UserType} from '../../util/uiconstants';

import * as TimeoutAction from '../../actions/timeoutactions';
import {setIsModalOpen} from '../../actions/AccessGroups/SetIsModalOpen';

import Dropdown from '../CoreWrappers/Dropdown';
import User from '../CoreWrappers/User';
import DelegateAccessModal from './DelegateAccessModal';

const NavOptionsContainer = (props) => {
	const [isModalVisible, setModalVisibility] = useState(false);
	const user = useSelector((store) => store.userPreferences);
	const paansuserdata = useSelector((store) => store.paansuserdata);

	const location = useLocation();
	const dispatch = useDispatch();
	const history = useHistory();

	const logoutUser = () => {
		dispatch(TimeoutAction.logoutUser());
	};

	const toggleModalVisibility = () => {
		setModalVisibility(false);
		dispatch(setIsModalOpen(true));
	};

	const verifyAdminToolUrl = (path = location.pathname) => {
		path = path !== null ? path.split('/') : null;
		if (path !== null && path.length > 1 && path[1].toLowerCase() === 'admin') {
			return true;
		}
		return false;
	};

	const redirectToPrivacyPolicy = () => {
		if (paansuserdata?.policyContentUrl) {
			window.open(paansuserdata?.policyContentUrl, '_blank');
		}
	};

	const renderTrigger = ({onClick = null, title = null}) => {
		const wrapperProps = {};

		if (onClick) wrapperProps.onClick = onClick;
		if (title) wrapperProps.title = title;

		const triggerProps = {
			firstName: user.firstName,
			lastName: user.lastName,
			email: user.emailAddress,
			showInfo: false,
			showAside: false,
			showPresence: true,
			showTitle: false,
			size: 'sm'
		};

		return (
			<div {...wrapperProps}>
				<User {...triggerProps} />
			</div>
		);
	};

	const renderDropdown = () => {
		const items = [
			{
				id: 1,
				label: labels.usersettings,
				onClick: () => history.push('/usersettings',{fromNavBar: true})
			}
		];

		if (
			user &&
			user.userType === UserType.Member &&
			(paansuserdata?.isPaansEnabled == false || paansuserdata?.hasAccepted == true)
		)
			items.push({
				id: 2,
				label: labels.delegateAccess,
				onClick: () => setModalVisibility(true)
			});

		if (paansuserdata?.isPaansEnabled && paansuserdata?.hasAccepted)
			items.push({
				id: 3,
				label: labels.privacyNotice,
				onClick: () => redirectToPrivacyPolicy()
			});

		if (user && user.userType === UserType.Guest)
			items.push({
				id: 4,
				label: labels.signout,
				onClick: logoutUser
			});

		const props = {
			placement: 'bottom-right',
			trigger: renderTrigger({title: verifyAdminToolUrl() === false && labels.userOptions}),
			items,
			reversed: true,
			topfix: true
		};

		return <Dropdown {...props} />;
	};

	return (
		<StyledNavOptions className={props.styleName}>
			{verifyAdminToolUrl() === false
				? renderDropdown()
				: renderTrigger({
						onClick: setModalVisibility,
						label: verifyAdminToolUrl() && `${user.firstName} ${user.lastName}`
				  })}

			<DelegateAccessModal
				showModal={isModalVisible}
				toggleModalVisibility={toggleModalVisibility}
				setModalVisibility={setModalVisibility}
			/>
		</StyledNavOptions>
	);
};

export default NavOptionsContainer;

const StyledNavOptions = styled.div`
	display: flex;
	.userimghold {
		--size: var(--px-30);
		width: var(--size);
		height: var(--size);
		.userimg {
			margin: 0;
			width: inherit;
			height: inherit;
		}
	}
	.userInfoDetails {
		display: none;
	}
`;
